import React, { useState } from 'react';
import { XCircle, FolderPlus } from 'lucide-react';

function CreateGroupModal({ onClose, onSubmit, loading, text, styles, spacing }) {
  const [newGroupName, setNewGroupName] = useState("");

  const handleSubmit = () => {
    onSubmit(newGroupName, () => {
      setNewGroupName("");
      onClose();
    });
  };

  const focusStyle = (e) => {
    e.currentTarget.style.borderColor = "#2e7cba";
    e.currentTarget.style.boxShadow = "0 0 0 4px rgba(46, 124, 186, 0.15)";
  };

  const blurStyle = (e) => {
    e.currentTarget.style.borderColor = styles.formInput.borderColor;
    e.currentTarget.style.boxShadow = "none";
  };

  return (
    <div style={styles.modal} onClick={onClose}>
      <div style={styles.modalContent} onClick={(e) => e.stopPropagation()}>
        {/* Header */}
        <div style={styles.modalHeader}>
          <h3 style={styles.modalTitle}>{text.createGroupTitle}</h3>
          <button
            style={styles.closeButton}
            onClick={onClose}
            onMouseEnter={(e) => {
              e.currentTarget.style.background = "rgba(46, 124, 186, 0.1)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.background = "none";
            }}
          >
            <XCircle size={28} />
          </button>
        </div>

        {/* Form Content */}
        <div style={styles.formGroup}>
          <label style={styles.formLabel}>
            {text.groupName} <span style={{ color: "#ef4444" }}>*</span>
          </label>
          <input
            type="text"
            value={newGroupName}
            onChange={(e) => setNewGroupName(e.target.value)}
            placeholder={text.enterGroupName}
            style={styles.formInput}
            onFocus={focusStyle}
            onBlur={blurStyle}
          />
        </div>

        {/* Actions */}
        <div style={styles.modalActions}>
          <button
            style={styles.secondaryButton}
            onClick={onClose}
          >
            {text.cancel}
          </button>
          <button
            style={styles.primaryButton}
            onClick={handleSubmit}
            disabled={loading}
          >
            <FolderPlus size={20} />
            {loading ? text.loading : text.create}
          </button>
        </div>
      </div>
    </div>
  );
}

export default CreateGroupModal;